export function getSubscriberRefIdQueryParam() {
  const params = new URLSearchParams(window.location.search);
  const subscriberRefId = params.get('subscriberRefId');
  return subscriberRefId ? subscriberRefId : undefined;
}

export default {
  getSubscriberRefIdQueryParam,
};
